import type { SVGProps } from "react";
const SvgCutlery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={68}
    height={68}
    fill="none"
    {...props}
  >
    <foreignObject width={10.824} height={34.962} x={19.793} y={28.063}>
      <div
        style={{
          backdropFilter: "blur(1px)",
          clipPath: "url(#cutlery_svg__a)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <path
      fill="url(#cutlery_svg__b)"
      d="M28.617 30.063V60.84l-3.852.185c-1.642 0-2.972-2.05-2.972-4.581V30.248z"
      data-figma-bg-blur-radius={2}
    />
    <foreignObject width={16.587} height={24.931} x={16.421} y={8.003}>
      <div
        style={{
          backdropFilter: "blur(1px)",
          clipPath: "url(#cutlery_svg__c)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <path
      fill="url(#cutlery_svg__d)"
      d="m21.457 13.04.078 13.262 1.7.038-.077-16.299a3.035 3.035 0 0 1 3.036 3.037l.077 13.262 1.7.04-.077-16.3a3.035 3.035 0 0 1 3.037 3.036l.077 17.817-10.81-.038c-1.677 0-1.7-1.398-1.7-3.075l-.077-17.817a3.035 3.035 0 0 1 3.036 3.036Z"
      data-figma-bg-blur-radius={2}
    />
    <foreignObject width={11.861} height={33.188} x={37.234} y={29.833}>
      <div
        style={{
          backdropFilter: "blur(1px)",
          clipPath: "url(#cutlery_svg__e)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <path
      fill="url(#cutlery_svg__f)"
      d="M43.165 61.02h3.93V31.834h-7.86v24.702c0 2.478 1.758 4.486 3.93 4.486Z"
      data-figma-bg-blur-radius={2}
    />
    <foreignObject width={13.146} height={35.514} x={36.009} y={4.815}>
      <div
        style={{
          backdropFilter: "blur(1px)",
          clipPath: "url(#cutlery_svg__g)",
          height: "100%",
          width: "100%",
        }}
      />
    </foreignObject>
    <path
      fill="url(#cutlery_svg__h)"
      d="M47.154 38.33H38.01V18.607c0-6.513 2.633-11.792 9.145-11.792z"
      data-figma-bg-blur-radius={2}
    />
    <path fill="#37B1FD" d="M39.243 31.835h7.859v6.496h-7.859z" opacity={0.3} />
    <path fill="#37B1FD" d="M39.243 32.648h7.859v5.682h-7.859z" opacity={0.3} />
    <path fill="#37B1FD" d="M39.243 33.464h7.859v4.868h-7.859z" opacity={0.3} />
    <path fill="#37B1FD" d="M39.243 34.278h7.859v4.053h-7.859z" opacity={0.3} />
    <path fill="#37B1FD" d="M39.243 35.091h7.859v3.239h-7.859z" opacity={0.3} />
    <defs>
      <linearGradient
        id="cutlery_svg__b"
        x1={28.617}
        x2={23.49}
        y1={59.138}
        y2={34.334}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009CFC" stopOpacity={0.8} />
        <stop offset={0.671} stopColor="#26B3FD" stopOpacity={0.6} />
        <stop offset={0.885} stopColor="#84EDFF" stopOpacity={0.8} />
        <stop offset={1} stopColor="#97F8FF" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="cutlery_svg__d"
        x1={24.715}
        x2={24.715}
        y1={27.933}
        y2={9.111}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009CFC" stopOpacity={0.6} />
        <stop offset={0.275} stopColor="#26B3FD" stopOpacity={0.4} />
        <stop offset={0.885} stopColor="#84EDFF" stopOpacity={0.8} />
        <stop offset={1} stopColor="#97F8FF" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="cutlery_svg__f"
        x1={47.096}
        x2={45.019}
        y1={59.749}
        y2={42.575}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009CFC" stopOpacity={0.8} />
        <stop offset={0.671} stopColor="#26B3FD" stopOpacity={0.6} />
        <stop offset={0.885} stopColor="#84EDFF" stopOpacity={0.8} />
        <stop offset={1} stopColor="#97F8FF" stopOpacity={0.8} />
      </linearGradient>
      <linearGradient
        id="cutlery_svg__h"
        x1={30.055}
        x2={53.339}
        y1={17.773}
        y2={21.071}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009CFC" stopOpacity={0.8} />
        <stop offset={0.333} stopColor="#26B3FD" stopOpacity={0.6} />
        <stop offset={0.76} stopColor="#84EDFF" stopOpacity={0.8} />
        <stop offset={1} stopColor="#97F8FF" stopOpacity={0.8} />
      </linearGradient>
      <clipPath id="cutlery_svg__a" transform="translate(-19.793 -28.063)">
        <path d="M28.617 30.063V60.84l-3.852.185c-1.642 0-2.972-2.05-2.972-4.581V30.248z" />
      </clipPath>
      <clipPath id="cutlery_svg__c" transform="translate(-16.42 -8.003)">
        <path d="m21.457 13.04.078 13.262 1.7.038-.077-16.299a3.035 3.035 0 0 1 3.036 3.037l.077 13.262 1.7.04-.077-16.3a3.035 3.035 0 0 1 3.037 3.036l.077 17.817-10.81-.038c-1.677 0-1.7-1.398-1.7-3.075l-.077-17.817a3.035 3.035 0 0 1 3.036 3.036Z" />
      </clipPath>
      <clipPath id="cutlery_svg__e" transform="translate(-37.234 -29.833)">
        <path d="M43.165 61.02h3.93V31.834h-7.86v24.702c0 2.478 1.758 4.486 3.93 4.486Z" />
      </clipPath>
      <clipPath id="cutlery_svg__g" transform="translate(-36.009 -4.815)">
        <path d="M47.154 38.33H38.01V18.607c0-6.513 2.633-11.792 9.145-11.792z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCutlery;
